import WujieVue from "wujie-vue3";
import lifecycles from "./lifecycle";
import hostMap from './hostMap';
import credentialsFetch from "./fetch";

export function setupWujie(app, router) {
  const isProduction = process.env.NODE_ENV === "production";
  const { setupApp, preloadApp, bus } = WujieVue;
  // 在 xxx-sub 路由下子应用将激活路由同步给主应用，主应用跳转对应路由高亮菜单栏
  bus.$on("sub-route-change", (name, path) => {
    const mainName = `${name}`;
    const mainPath = `/${name}${path}`;
    const currentName = router.currentRoute.value.name;
    const currentPath = router.currentRoute.value.path;
    if (mainName !== currentName.substring(1)) {
      // TODO 高亮菜单栏
    }
  });

  bus.$on("sidebar-toggle", (flag) => {

  })
  
  router.afterEach((to, from) => {
    bus.$emit("main-route-change", "mall", to.path);
  })

  const degrade = window.localStorage.getItem("degrade") === "true" || !window.Proxy || !window.CustomElementRegistry;
  const props = {
    jump: (name) => {
      router.push({ name });
    },
  };
  /**
   * 大部分业务无需设置 attrs
   * 此处修正 iframe 的 src，是防止github pages csp报错
   * 因为默认是只有 host+port，没有携带路径
   */
  // const attrs = isProduction ? { src: hostMap("//localhost:9091/mall/") } : {};
  setupApp({
    name: "mall",
    url: hostMap("//localhost:9091/mall/"),
    attrs: { src: hostMap("//localhost:9091/mall/") + 'empty' },
    exec: true,
    alive: true,
    plugins: [{ cssExcludes: ["https://stackpath.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css"] }],
    props,
    // 引入了的第三方样式不需要添加credentials
    fetch: (url, options) =>
      (url as string).includes(hostMap("//localhost:7300/")) ? credentialsFetch(url, options) : window.fetch(url, options),
    degrade,
    ...lifecycles,
  });

  setupApp({
    name: "spms",
    url: hostMap("//localhost:9091/spms/"),
    attrs: { src: hostMap("//localhost:9091/spms/") + 'empty' },
    exec: true,
    alive: true,
    plugins: [{ cssExcludes: ["https://stackpath.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css"] }],
    props,
    // 引入了的第三方样式不需要添加credentials
    fetch: (url, options) =>
      (url as string).includes(hostMap("//localhost:7300/")) ? credentialsFetch(url, options) : window.fetch(url, options),
    degrade,
    ...lifecycles,
  });
}
